import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import RegulatoryOffering from "@/pages/RegulatoryOffering";

export const Route = createFileRoute("/es/servicios/regulatory-affairs/soporte-para-la-transición-de-ivdd-a-ivdr")({
  head: () => buildRouteHead("/es/servicios/regulatory-affairs/soporte-para-la-transición-de-ivdd-a-ivdr"),
  component: RegulatoryOffering,
});

